import Vue from 'vue'
import Vuex from 'vuex'
// import permission from './permission'
import { adminRouterMap, merchantRouterMap, agentRouterMap, constantRouterMap } from '@/router'
import { addClassName, delClassName } from '@/utils/index'

Vue.use(Vuex)

Vue.directive('handle', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el, binding) {
    var getCodeList = localStorage.getItem('codeList')
    var myCodeList = getCodeList ? JSON.parse(getCodeList) : []
    if (myCodeList.indexOf(binding.value) === -1) {
      el.parentNode.removeChild(el)
    }
  }
})

Vue.prototype.outhHandle = function (binding) {
  var getCodeList = localStorage.getItem('codeList')
  var myCodeList = getCodeList ? JSON.parse(getCodeList) : []
  if (myCodeList.indexOf(binding) === -1) {
    return false
  } else {
    return true
  }
}

// 防止el-button重复点击
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true;//禁用属性
        // 添加 禁用样式、loading样式
        addClassName(el, 'is-disabled');
        addClassName(el, 'is-loading');
        // 手动创建loading图标
        let loadingIcon = document.createElement("i");
        loadingIcon.className = 'el-icon-loading'
        el.prepend(loadingIcon);

        setTimeout(() => {
          el.disabled = false;
          delClassName(el, 'is-disabled');
          delClassName(el, 'is-loading');
          // 手动移除loading图标
          el.removeChild(loadingIcon)
        }, binding.value || 2000)
      }
    })
  }
});

function getRouteBase() {
  let base
  if (Vue.prototype.MerchantHost.indexOf(document.domain) > -1) {
    base = Vue.prototype.Merchant
  } else if (Vue.prototype.ManageHost.indexOf(document.domain) > -1) {
    base = Vue.prototype.Manage
  } else if (Vue.prototype.AgentHost.indexOf(document.domain) > -1) {
    base = Vue.prototype.Agent
  } else if (Vue.prototype.ManageHostAndMerchantHost.indexOf(document.domain) === -1) {
    base = Vue.prototype.OpenService
  }
  return base
}

// 权限过滤
function filterRoutes(routes) {
  var arr = []
  var getCodeList = localStorage.getItem('codeList')
  var myCodeList = getCodeList ? JSON.parse(getCodeList) : []
  for (var i = 0; i < routes.length; i++) {
    var cur = Object.assign({}, routes[i])
    var curChild = cur.children.filter(item => {
      return myCodeList.indexOf(cur.path.replace('/', '') + ':' + item.path) > -1 || item.hidden
    })
    if (curChild.filter(item => !item.hidden).length) {
      cur.children = curChild
      arr.push(cur)
    }
  }
  return arr
}

// 显隐设置-商户后台
function showHiddenRoutesForMerchant(routes) {
  const user = localStorage.getItem("userInfo")
  const merType = user ? JSON.parse(user).merType : null;//商户类型 1 代收,2 代付
  const CollectMerHiddens = ['代收商户提现', '代付商户提现', '对公代付', '代付记录', '网银充值', 'USDT充值', '商户USDT充值', '商户会员', '代付订单', '代付拦截', '待审核提现订单', '已审核提现订单', '修改支付密码'];//代收商户 隐藏菜单名单
  const PaymentMerHiddens = ['代收商户提现', '代付商户提现', '商户会员', '对公代付', '修改支付密码', '代付记录', '商户提现订单', 'USDT订单'];//代付商户 隐藏菜单名单

  for (var i = 0; i < routes.length; i++) {
    var cur = Object.assign({}, routes[i])
    cur.children && cur.children.forEach(item => {
      if (merType == 1) {//代收商户后台
        if (CollectMerHiddens.includes(item.meta.title)) {//隐藏菜单
          Vue.set(item, 'hidden', true);
        } else {
          Vue.set(item, 'hidden', false);
        }
      }
      if (merType == 2) {//代付商户后台
        if (PaymentMerHiddens.includes(item.meta.title)) {//隐藏菜单
          Vue.set(item, 'hidden', true);
        } else {
          Vue.set(item, 'hidden', false);
        }
      }
    });
  }
  return routes
}

// 显隐设置-代理后台
function showHiddenRoutesForAgent(routes) {
  const user = localStorage.getItem("userInfo")
  const agentType = user ? JSON.parse(user).agentLevel : null;//代理类型 1 父级,2 子级
  const ParentAgeHiddens = [];//父级代理 隐藏菜单名单
  const ChildAgeHiddens = ['代理列表'];//子级代理 隐藏菜单名单

  const agentPayType = user ? JSON.parse(user).payType : null;//代理类型 1 代收,2 代付
  const CollectAgeHiddens = ['USDT充值订单'];//代收代理 隐藏菜单名单
  const PaymentAgeHiddens = ['USDT代收订单'];//代付代理 隐藏菜单名单

  for (var i = 0; i < routes.length; i++) {
    var cur = Object.assign({}, routes[i])
    cur.children && cur.children.forEach(item => {
      if (agentType == 1) {//父级代理
        if (ParentAgeHiddens.includes(item.meta.title)) {//隐藏菜单
          Vue.set(item, 'hidden', true);
        } else {
          if (agentPayType == 1) {//代收代理后台
            if (CollectAgeHiddens.includes(item.meta.title)) {//隐藏菜单
              Vue.set(item, 'hidden', true);
            } else {
              Vue.set(item, 'hidden', false);
            }
          }
          if (agentPayType == 2) {//代付代理后台
            if (PaymentAgeHiddens.includes(item.meta.title)) {//隐藏菜单
              Vue.set(item, 'hidden', true);
            } else {
              Vue.set(item, 'hidden', false);
            }
          }
        }
      }
      if (agentType == 2) {//子级代理
        if (ChildAgeHiddens.includes(item.meta.title)) {//隐藏菜单
          Vue.set(item, 'hidden', true);
        } else {
          if (agentPayType == 1) {//代收代理后台
            if (CollectAgeHiddens.includes(item.meta.title)) {//隐藏菜单
              Vue.set(item, 'hidden', true);
            } else {
              Vue.set(item, 'hidden', false);
            }
          }
          if (agentPayType == 2) {//代付代理后台
            if (PaymentAgeHiddens.includes(item.meta.title)) {//隐藏菜单
              Vue.set(item, 'hidden', true);
            } else {
              Vue.set(item, 'hidden', false);
            }
          }
        }
      }
    });
  }
  return routes
}

const store = new Vuex.Store({
  state: {
    routers: constantRouterMap,
    addRouters: [],
    addRoles: '',
    removeTagName: ''
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
      state.addRoles = true
    },
    clear_addRoles: (state) => {
      state.addRoles = ''
      // state.routers = constantRouterMap
    },
    doRemoveTag: (state, tagName) => {
      state.removeTagName = tagName
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        var res = []
        var routeType = getRouteBase()
        if (routeType === '/admin') {
          res = filterRoutes(adminRouterMap)//权限过滤
          // res = adminRouterMap
        } else if (routeType === '/merchant') {
          res = showHiddenRoutesForMerchant(filterRoutes(merchantRouterMap))//显隐过滤+权限过滤
          // res = merchantRouterMap
        } else {
          res = showHiddenRoutesForAgent(agentRouterMap)//显隐过滤
          // res = agentRouterMap
        }
        res.push({ path: '*', redirect: '/home', hidden: true })
        commit('SET_ROUTERS', res)
        resolve()
      })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js